// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalStatusDetalhe_dialogPaper__RKDCQ {
  border-radius: 12px !important;
  overflow: hidden;
}

.ModalStatusDetalhe_header__KZkmA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.5rem !important;
  border-bottom: 1px solid #e8ecf4;
  background: linear-gradient(180deg, #f7f9fc 0%, #fff 100%);
}

.ModalStatusDetalhe_headerTitle__KMslA {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.ModalStatusDetalhe_headerIcon__dTl1z {
  color: #18316e;
}

.ModalStatusDetalhe_title__ux-1L {
  margin: 0 !important;
  font-size: 1.15rem !important;
  font-weight: 700 !important;
  color: #18316e !important;
  line-height: 1.3 !important;
}

.ModalStatusDetalhe_content__FVhHQ {
  display: flex !important;
  flex-direction: column !important;
  gap: 1rem !important;
  padding: 1.25rem 1.5rem !important;
}

.ModalStatusDetalhe_metaGrid__Koo5X {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid #e8ecf4;
  border-radius: 10px;
  background: #fafbfd;
}

.ModalStatusDetalhe_metaItem__5iijZ {
  min-width: 0;
}

.ModalStatusDetalhe_metaLabel__zDysu {
  display: block;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7a99;
  margin-bottom: 0.2rem;
}

.ModalStatusDetalhe_metaValue__gK9dp {
  font-size: 0.875rem;
  color: #1a1a1a;
  word-break: break-word;
}

.ModalStatusDetalhe_resumo__dleYY {
  margin: 0 !important;
  border-radius: 10px !important;
}

.ModalStatusDetalhe_timeline__LpNXH {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ModalStatusDetalhe_eventCard__ZYKCS {
  display: flex;
  gap: 0.75rem;
  padding: 0.85rem 0.95rem;
  border-radius: 10px;
  border: 1px solid #e8ecf4;
  background: #fff;
}

.ModalStatusDetalhe_eventCardErro__pVLHI {
  border-color: #ffcdd2;
  background: linear-gradient(90deg, #fff5f5 0%, #fff 28%);
}

.ModalStatusDetalhe_eventCardDivergencia__CV\\+06 {
  border-color: #ffe082;
  background: linear-gradient(90deg, #fffbeb 0%, #fff 28%);
}

.ModalStatusDetalhe_eventRail__uTsXf {
  width: 4px;
  flex-shrink: 0;
  border-radius: 4px;
  margin-top: 0.15rem;
  align-self: stretch;
  min-height: 2.5rem;
}

.ModalStatusDetalhe_eventRailErro__M5KCl {
  background: #c62828;
}

.ModalStatusDetalhe_eventRailDivergencia__Onm\\+3 {
  background: #f9a825;
}

.ModalStatusDetalhe_eventBody__y6fzR {
  min-width: 0;
  flex: 1 1;
}

.ModalStatusDetalhe_eventTop__EoHaJ {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.4rem;
}

.ModalStatusDetalhe_eventMsg__-td-N {
  margin: 0 !important;
  font-size: 0.875rem !important;
  color: rgba(0, 0, 0, 0.82) !important;
  line-height: 1.45 !important;
  white-space: pre-wrap;
  word-break: break-word;
}

.ModalStatusDetalhe_eventMeta__rhFAH {
  margin-top: 0.35rem;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.5);
}

.ModalStatusDetalhe_emptyState__cDV6v {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 1.5rem 1rem;
  border: 1px dashed #d5dbe8;
  border-radius: 10px;
  background: #fafbfd;
  text-align: center;
}

.ModalStatusDetalhe_emptyIcon__jcrd3 {
  color: #9aa8c3;
  font-size: 1.75rem !important;
}

.ModalStatusDetalhe_emptyText__QelY9 {
  margin: 0 !important;
  font-size: 0.875rem !important;
  color: rgba(0, 0, 0, 0.55) !important;
}

.ModalStatusDetalhe_actions__zyI\\+E {
  display: flex !important;
  justify-content: space-between !important;
  gap: 0.75rem;
  padding: 0.85rem 1.5rem 1.25rem !important;
  border-top: 1px solid #e8ecf4;
  margin: 0 !important;
}

.ModalStatusDetalhe_btnFechar__U3sRE {
  background: #fff !important;
  border: 1px solid #18316e !important;
  color: #18316e !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.ModalStatusDetalhe_btnVerFila__QeySO {
  background: #18316e !important;
  border: 1px solid #18316e !important;
  color: #fff !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

@media (max-width: 600px) {
  .ModalStatusDetalhe_metaGrid__Koo5X {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Apuracoes/components/ModalStatusDetalhe.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iCAAiC;EACjC,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;EACrC,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".dialogPaper {\n  border-radius: 12px !important;\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.1rem 1.5rem !important;\n  border-bottom: 1px solid #e8ecf4;\n  background: linear-gradient(180deg, #f7f9fc 0%, #fff 100%);\n}\n\n.headerTitle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.headerIcon {\n  color: #18316e;\n}\n\n.title {\n  margin: 0 !important;\n  font-size: 1.15rem !important;\n  font-weight: 700 !important;\n  color: #18316e !important;\n  line-height: 1.3 !important;\n}\n\n.content {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 1rem !important;\n  padding: 1.25rem 1.5rem !important;\n}\n\n.metaGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.65rem 1rem;\n  padding: 0.85rem 1rem;\n  border: 1px solid #e8ecf4;\n  border-radius: 10px;\n  background: #fafbfd;\n}\n\n.metaItem {\n  min-width: 0;\n}\n\n.metaLabel {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #6b7a99;\n  margin-bottom: 0.2rem;\n}\n\n.metaValue {\n  font-size: 0.875rem;\n  color: #1a1a1a;\n  word-break: break-word;\n}\n\n.resumo {\n  margin: 0 !important;\n  border-radius: 10px !important;\n}\n\n.timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.eventCard {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.85rem 0.95rem;\n  border-radius: 10px;\n  border: 1px solid #e8ecf4;\n  background: #fff;\n}\n\n.eventCardErro {\n  border-color: #ffcdd2;\n  background: linear-gradient(90deg, #fff5f5 0%, #fff 28%);\n}\n\n.eventCardDivergencia {\n  border-color: #ffe082;\n  background: linear-gradient(90deg, #fffbeb 0%, #fff 28%);\n}\n\n.eventRail {\n  width: 4px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  margin-top: 0.15rem;\n  align-self: stretch;\n  min-height: 2.5rem;\n}\n\n.eventRailErro {\n  background: #c62828;\n}\n\n.eventRailDivergencia {\n  background: #f9a825;\n}\n\n.eventBody {\n  min-width: 0;\n  flex: 1;\n}\n\n.eventTop {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n  margin-bottom: 0.4rem;\n}\n\n.eventMsg {\n  margin: 0 !important;\n  font-size: 0.875rem !important;\n  color: rgba(0, 0, 0, 0.82) !important;\n  line-height: 1.45 !important;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.eventMeta {\n  margin-top: 0.35rem;\n  font-size: 0.75rem;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  padding: 1.5rem 1rem;\n  border: 1px dashed #d5dbe8;\n  border-radius: 10px;\n  background: #fafbfd;\n  text-align: center;\n}\n\n.emptyIcon {\n  color: #9aa8c3;\n  font-size: 1.75rem !important;\n}\n\n.emptyText {\n  margin: 0 !important;\n  font-size: 0.875rem !important;\n  color: rgba(0, 0, 0, 0.55) !important;\n}\n\n.actions {\n  display: flex !important;\n  justify-content: space-between !important;\n  gap: 0.75rem;\n  padding: 0.85rem 1.5rem 1.25rem !important;\n  border-top: 1px solid #e8ecf4;\n  margin: 0 !important;\n}\n\n.btnFechar {\n  background: #fff !important;\n  border: 1px solid #18316e !important;\n  color: #18316e !important;\n  text-transform: none !important;\n  font-weight: 600 !important;\n}\n\n.btnVerFila {\n  background: #18316e !important;\n  border: 1px solid #18316e !important;\n  color: #fff !important;\n  text-transform: none !important;\n  font-weight: 600 !important;\n}\n\n@media (max-width: 600px) {\n  .metaGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogPaper": `ModalStatusDetalhe_dialogPaper__RKDCQ`,
	"header": `ModalStatusDetalhe_header__KZkmA`,
	"headerTitle": `ModalStatusDetalhe_headerTitle__KMslA`,
	"headerIcon": `ModalStatusDetalhe_headerIcon__dTl1z`,
	"title": `ModalStatusDetalhe_title__ux-1L`,
	"content": `ModalStatusDetalhe_content__FVhHQ`,
	"metaGrid": `ModalStatusDetalhe_metaGrid__Koo5X`,
	"metaItem": `ModalStatusDetalhe_metaItem__5iijZ`,
	"metaLabel": `ModalStatusDetalhe_metaLabel__zDysu`,
	"metaValue": `ModalStatusDetalhe_metaValue__gK9dp`,
	"resumo": `ModalStatusDetalhe_resumo__dleYY`,
	"timeline": `ModalStatusDetalhe_timeline__LpNXH`,
	"eventCard": `ModalStatusDetalhe_eventCard__ZYKCS`,
	"eventCardErro": `ModalStatusDetalhe_eventCardErro__pVLHI`,
	"eventCardDivergencia": `ModalStatusDetalhe_eventCardDivergencia__CV+06`,
	"eventRail": `ModalStatusDetalhe_eventRail__uTsXf`,
	"eventRailErro": `ModalStatusDetalhe_eventRailErro__M5KCl`,
	"eventRailDivergencia": `ModalStatusDetalhe_eventRailDivergencia__Onm+3`,
	"eventBody": `ModalStatusDetalhe_eventBody__y6fzR`,
	"eventTop": `ModalStatusDetalhe_eventTop__EoHaJ`,
	"eventMsg": `ModalStatusDetalhe_eventMsg__-td-N`,
	"eventMeta": `ModalStatusDetalhe_eventMeta__rhFAH`,
	"emptyState": `ModalStatusDetalhe_emptyState__cDV6v`,
	"emptyIcon": `ModalStatusDetalhe_emptyIcon__jcrd3`,
	"emptyText": `ModalStatusDetalhe_emptyText__QelY9`,
	"actions": `ModalStatusDetalhe_actions__zyI+E`,
	"btnFechar": `ModalStatusDetalhe_btnFechar__U3sRE`,
	"btnVerFila": `ModalStatusDetalhe_btnVerFila__QeySO`
};
export default ___CSS_LOADER_EXPORT___;
